import React, { FC } from 'react';

import { Tab } from '../HeroContainer/HeroContainer.types';
import homepageTranslations from 'public/locales/en/homepage.json';
import { getTranslator } from '../../../shared/i18n/getTranslator';
import { BuyRentTabsWrapper, BuyRentTab } from './BuyRentTabs.styles';

const t = getTranslator(homepageTranslations);

export type Props = {
    onPress: (tab: Tab) => void;
    selected: Tab;
    includeHousePrices: boolean;
};

const buyTabText = t('search_tabs.buy');
const rentTabText = t('search_tabs.rent');
const housePricesTabText = t('search_tabs.house_prices');

export const BuyRentTabs: FC<Props> = ({ onPress, selected, includeHousePrices }) => {
    return (
        <BuyRentTabsWrapper includeHousePrices={includeHousePrices}>
            <BuyRentTab
                onClick={() => onPress('for-sale')}
                isBold={selected === 'for-sale'}
                width="78px"
                data-testid="for-sale-tab"
            >
                {buyTabText}
            </BuyRentTab>
            <BuyRentTab
                onClick={() => onPress('to-rent')}
                isBold={selected === 'to-rent'}
                width="78px"
                data-testid="to-rent-tab"
            >
                {rentTabText}
            </BuyRentTab>
            {includeHousePrices ? (
                        <BuyRentTab
                        onClick={() => onPress('house-prices')}
                        isBold={selected === 'house-prices'}
                        width="107px"
                        data-testid="house-prices-tab"
                    >
                        {housePricesTabText}
                    </BuyRentTab>
                    ) : null}        
        </BuyRentTabsWrapper>
    );
};
